module.exports = __webpack_public_path__ + "static/media/what-new-banner-desktop.0f81bcff.jpg";